import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const promises = [
  "Optimizo procesos para eliminar fugas de leads",
  "Reduzco pérdidas por respuesta lenta o inexistente",
  "Mejoro seguimiento comercial y reactivación",
  "Maximizo cada peso invertido en publicidad",
];

export default function Guarantee() {
  return (
    <section id="guarantee" data-testid="guarantee-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-radial-orange opacity-80" />
      <div className="container-x relative">
        <div className="reveal grad-border p-8 sm:p-14 lg:p-20 relative overflow-hidden">
          <div className="absolute -top-32 -right-20 w-[520px] h-[520px] bg-gradient-to-br from-[#ff3b1f]/30 via-[#ff8a00]/20 to-transparent rounded-full blur-3xl" />
          <div className="grid lg:grid-cols-12 gap-10 items-center relative">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass">
                <ShieldCheck className="w-4 h-4 text-[#ffd23f]" />
                <span className="text-[11px] tracking-[0.22em] uppercase font-display font-semibold text-[#ffd23f]">Mi promesa</span>
              </div>
              <h2 className="mt-6 font-display font-extrabold text-white text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[1] text-glow">
                Gana más,<br />
                <span className="text-gradient">pierde cero.</span>
              </h2>
              <p className="mt-7 text-zinc-300 text-lg max-w-2xl leading-relaxed">
                No prometo crecimientos imposibles. Prometo cerrar las fugas que hoy te están costando ventas y construir un sistema donde cada lead se trabaja, cada peso se mide y cada conversación cuenta.
              </p>
            </div>

            <div className="lg:col-span-5">
              <ul className="space-y-3">
                {promises.map((p) => (
                  <li key={p} className="flex items-start gap-3 glass rounded-xl px-4 py-3.5">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-gradient-brand shrink-0" />
                    <span className="text-zinc-200 text-[15px]">{p}</span>
                  </li>
                ))}
              </ul>
              <Link to="/contacto" className="btn-primary mt-7 w-full sm:w-auto justify-center" data-testid="guarantee-cta">
                Quiero esa garantía
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
